import { ActivatedRouteSnapshot, Router } from '@angular/router';

/** Token-authorized email quick-reply — no JWT session required. */
export const NOTIFICATION_REPLY_ROUTE_PATTERN =
  /\/[^/]+\/notifications\/reply\/?(?:\?|$)/;

export function isNotificationReplyRoute(url: string): boolean {
  return NOTIFICATION_REPLY_ROUTE_PATTERN.test(url);
}

/**
 * Reads `tenantId` from the current route tree (e.g. `/:tenantId/leads`).
 * Matches auth interceptor behavior — empty string when not on a tenant-scoped route.
 */
export function getTenantIdFromRouter(router: Router): string {
  let route: ActivatedRouteSnapshot | null = router.routerState.snapshot.root;
  while (route) {
    const tenantId = route.paramMap.get('tenantId');
    if (tenantId) {
      return tenantId;
    }
    route = route.firstChild ?? null;
  }
  return '';
}
